module.exports = __webpack_public_path__ + "static/media/mumbai.e7b43c3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/mumbai.jpg
// module id = 985
// module chunks = 0